export const isOS = (): boolean => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
